import React, { Fragment, useRef, useState } from 'react'
import { Row, Col, Accordion } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Input } from 'antd'
import useSWR from 'swr'

import coursesStarted from 'api/courses/coursesStarted'
import { paths } from 'routes/paths'
import { EmptyStateBanner } from 'components/ui/empty-states/empty-state-banner'
import { CategoryHeader } from 'pages/Library/components/CategoryHeader/CategoryHeader'
import { AccordionCard } from 'components/ui/AccordionCard'
import { AccordionToggle } from 'components/ui/AccordionToggle'
import { CourseHorizontalCard } from '../../../../components/ui/CourseCards/components/molecules'
import styles from './CoursesProgress.module.scss'

const CoursesProgress: React.FC<{
  search: string
  onChangeSearch: (value: string) => void
}> = ({ search, onChangeSearch }) => {
  const { t } = useTranslation()
  const searchDebounced = useRef<number>()
  const [inputValue, setSearch] = useState('')

  const { data, isLoading } = useSWR(
    { key: 'coursesProgress', search },
    async (arg) =>
      coursesStarted({
        page: 1,
        perPage: 4,
        search: arg.search,
      })
  )

  const courses = data?.courses || []
  const total = data?.total || 0

  const title = t('newhome.sections.coursesProgress.containerSubtitle')
  return (
    <Fragment>
      <Row>
        <Col lg={{ span: 3 }}>
          <p className={styles.containerTitle}>
            {t('newhome.sections.coursesProgress.initiation')}
          </p>
        </Col>
        <Col lg={{ span: 3, offset: 6 }} className="mb-4">
          <Input.Search
            placeholder={t('home.lmsIndex.search.placeholder')}
            className={styles.search}
            value={inputValue}
            onChange={(e: any) => {
              clearTimeout(searchDebounced.current)
              const value = e.target.value
              setSearch(value)
              searchDebounced.current = window.setTimeout(() => {
                onChangeSearch(value)
              }, 1000)
            }}
          />
        </Col>
      </Row>
      <Accordion defaultActiveKey={title}>
        <AccordionCard>
          <AccordionToggle eventKey={title}>
            <CategoryHeader
              title={title}
              count={total}
              showMoreText={t(
                'newhome.sections.coursesProgress.linkCoursesProgress'
              )}
              showMoreLink={paths.home.advanceCourses.details('in_progress')}
            />
          </AccordionToggle>
          <Accordion.Collapse eventKey={title}>
            <Row>
              {courses && courses.length > 0 ? (
                courses?.map(({ course, enrol }) => (
                  <Col
                    lg={6}
                    xs={12}
                    sm={12}
                    md={12}
                    key={course.id}
                    className={styles.containerCourse}
                  >
                    <CourseHorizontalCard
                      course={course}
                      enrol={enrol}
                      directToLessons={true}
                      enrolled={true}
                      maxWidth={'100%'}
                    />
                  </Col>
                ))
              ) : isLoading ? null : (
                <Col
                  xs={12}
                  md={12}
                  xl={12}
                  lg={12}
                  className={styles.emptyState}
                >
                  <EmptyStateBanner
                    text={t('newhome.emptyStates.byState.inProgress.text')}
                    subtext={t(
                      'newhome.emptyStates.byState.inProgress.subtext'
                    )}
                    link={{
                      href: paths.library.root,
                      text: t('newhome.emptyStates.byState.inProgress.link'),
                    }}
                  />
                </Col>
              )}
            </Row>
          </Accordion.Collapse>
        </AccordionCard>
      </Accordion>
    </Fragment>
  )
}

export default CoursesProgress
